"use client"

import { Chip, ChipProps, SxProps, Theme } from "@mui/material"
import Link from "next/link"

interface Props extends ChipProps {
    tagName: string
    tagSlug?: string
}

export const TagChip = ({ tagName, tagSlug, sx = {}, ...props }: Props) => {
    const style = { ...styles.chip, ...sx }
    const clickable = tagSlug !== undefined

    if (!clickable)
        return (
            <Chip
                component="div"
                clickable={false}
                label={tagName}
                variant="outlined"
                sx={style}
                {...props}
            />
        )

    return (
        <Link
            onClick={(e) => e.stopPropagation()}
            href={tagSlug ? `/summaries/${tagSlug}/1` : "/summaries/"}
            style={{ textDecoration: "none" }}
        >
            <Chip
                component="div"
                clickable={clickable}
                label={tagName}
                variant="outlined"
                size="small"
                color={props.variant === "filled" ? "primary" : "default"}
                sx={style}
                {...props}
            />
        </Link>
    )
}

const styles: Record<string, SxProps<Theme>> = {
    chip: {
        borderColor: "action.disabled",
    },
}
